"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Navigation = (props) => {
    const [value, setValue] = react_1.default.useState(props.initalSelectedMenuIndex || 0);
    const useStyles = styles_1.makeStyles(() => styles_1.createStyles({
        root: {
            width: props.width || "100vw",
            height: props.height || "12vh",
            boxShadow: props.shadow
                ? "0px -2px 4px -1px rgb(0 0 0 / 20%), 0px -4px 5px 0px rgb(0 0 0 / 14%), 0px -1px 10px 0px rgb(0 0 0 / 12%)"
                : "none",
        },
    }));
    const classes = useStyles();
    const handleMenuClick = (event, newValue) => {
        setValue(newValue);
        props.handleActionButtonClick(event.currentTarget.innerText);
    };
    const renderActionButtons = () => (props.data || []).map((buttonData, index) => (react_1.default.createElement(core_1.BottomNavigationAction, { icon: buttonData.icon, key: `actionButton-${index}`, label: buttonData.title })));
    return (react_1.default.createElement(core_1.BottomNavigation, { className: classes.root, onChange: handleMenuClick, showLabels: true, value: value }, renderActionButtons()));
};
exports.default = Navigation;
//# sourceMappingURL=index.js.map